
import { Component, Mixins } from 'vue-property-decorator';
// @ is an alias to /src
import FormKeywordRecommend from '@/components/form/FormKeywordRecommend/FormKeywordRecommend.vue';
import SidenaviSearchkeyword from './';
const Words: Dictionary = {
  label: 'キーワードから検索する',
};
@Component({
  components: {
    FormKeywordRecommend,
  },
})
export default class SidenaviSearchkeywordJa extends Mixins(SidenaviSearchkeyword) {
  private words = Words;
}
